export default __webpack_public_path__ + "static/media/Binary.f59de8e3.svg";